export function saveBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  // jsdom has no navigation; skip the real click there so tests stay quiet.
  const isJsdom =
    typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent || '');
  if (!isJsdom) {
    anchor.click();
  }
  anchor.remove();
  // Revoke after the click has been handed to the browser's download manager.
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
